if (!customElements.get('newsletter-footer')) {
  class NewsletterFooter extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.klaviyoListId = this.getAttribute('data-klaviyo-list-id') || null;
      this.email = this.querySelector('input[type="text"]');
      this.companyId = 'ktNuRu'

      if (this.klaviyoListId) {
        this.form.addEventListener('submit', this.sendForm.bind(this));
      } else {
        console.error('Klaviyo form id not found.');
      }
    }

    formData() {
      return {
        method: 'POST',
        headers: {revision: '2024-02-15', 'content-type': 'application/json'},
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Footer signup form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: (this.querySelector('input[name="email"]')) ? this.querySelector('input[name="email"]').value : '',
                  }
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: this.klaviyoListId}}}
          }
        })
      };
    }

    showMessage(type) {
      this.querySelector('.footer-newsletter__' + type).classList.remove('hidden');

      setTimeout(() => {
        this.querySelector('.footer-newsletter__' + type).classList.add('hidden');
      }, 6000)
    }

    sendForm(event) {
      event.preventDefault();
      const _this = this;
      const successMessage = _this.querySelector('.footer-newsletter__success');
      const field = _this.querySelector('.field-with-submit__wrapper');

      if (this.emailValidation()) {
        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`, this.formData())
          .then(response => { if (response.status === 202) {
            successMessage.classList.remove('hidden');
            field.style.pointerEvents = 'none';
          } else {
            _this.showMessage("error")
          }
          })
          .catch(err => {console.error(err); _this.showMessage("error")});

      } else {
        this.showMessage("error-email");
      }
    }

    emailValidation() {
        if (this.email) {
          const emailValue = this.email.value;
          const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          const result = re.test(emailValue);

          return result && result != ''
        } else {
          return true;
        }
    }
  }
  customElements.define("newsletter-footer", NewsletterFooter);
}
